import React from 'react';
import {PropTypes} from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import {ToString, FormatString, NormalizeClassNameString, InitTooltips} from './utils';
import {ErrorsBlockComponent} from '../shared/errorsBlockComponent';

function isTextWithHtml(text) {
    return /\<[a-z][a-z0-9]*\s*(\s+[^\s\r\0\"\'\>\=\/]+|\s+[^\s\r\0\"\'\>\=\/]+\s*=\s*[^\r\0\"\'\>\<\=\`\s]+|\s+[^\s\r\0\"\'\>\=\/]+\s*=\s*\"[^\r\n\t\0\"]*\"|\s+[^\s\r\0\"\'\>\=\/]+\s*=\s*\'[^\r\n\t\0\']*\')*\s*\/?\>/igm.test(ToString(text));
}

function isTextHasHtmlForm(text) {
    return /\<a\s+[^\>\<]*href=[^\<\>]*\>|\<input\s+[^\>\<]*type=[^\>\<]*\>|\<(select|button|textarea)[^\<\>]*\>/igm.test(ToString(text));
}

const fixedWith = 450;
const showDelay = 100;
const preventDefault = e => e.preventDefault();

$(document)
    .on('click', '.btn-copy-popover-content', function () {
        const $popoverBody = $(this)
            .closest('.popover')
            .find('.popover-body');

        let str = null;

        if (($popoverBody.length > 0) ) {
            str = $popoverBody.get(0).textContent;
        }

        if (str == null) {
            str = $popoverBody.text() || '';
        }

        window.AppUtils.PutTextToClipboard(str);
    });


export class ItemPopupDescriptionComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);

        this.constructor.popoverCounter++;
        this._popoverId = 'pd-popover-' + this.constructor.popoverCounter;
        this._needRecreatePopover = false;
        this.$popover = null;

        this.isHidden = this.isHidden.bind(this);

        this.state = {
            isLoaded: typeof props.text !== 'function', 
            isLoading: false, 
            popoverConfig: this.getPopoverConfig(props)
        };

        this.getPopoverConfig = this.getPopoverConfig.bind(this);
        this.needContent = this.needContent.bind(this);
        this.createPopover = this.createPopover.bind(this);
        this.destroyPopover = this.destroyPopover.bind(this);
        this.updatePopover = this.updatePopover.bind(this);
    }

    componentDidMount() {
        InitTooltips();
        const self = this;

        self._isMounted = true;
        self.createPopover();
    }

    componentWillUnmount() {
        const self = this;

        self._isMounted = false;
        self.destroyPopover();
    }

    componentDidUpdate(){
        const self = this;
        const popoverConfig = self.getPopoverConfig();
        self.setState(
            {popoverConfig: popoverConfig},
            () => {
                setTimeout(
                    self.updatePopover,
                    showDelay + 100
                );
            });
    }

    shouldComponentUpdate(nextProps, nextState) {
        const self = this;
        const {props, state} = self;

        let result = 
            (props.className != nextProps.className) ||
            (props.popoverClassName != nextProps.popoverClassName) ||
            (props.placement != nextProps.placement) ||
            (props.children != nextProps.children) ||
            (state.isLoaded != nextState.isLoaded) ||
            (state.isLoading != nextState.isLoading) ||
            (JSON.stringify(state.popoverConfig) != (JSON.stringify(nextState.popoverConfig)));

        if (!result) {
            const config = self.getPopoverConfig(props);
            const nextConfig = self.getPopoverConfig(nextProps);
            
            result = config.content != nextConfig.content;
        }

        return result;
    }

    createPopover() {
        const self = this;

        if (self._isMounted && !Boolean(self.$popover)) {
            self.$popover = $(`.popup-description[data-toggle="${self._popoverId}"]`).popover(self.state.popoverConfig);
            self.$popover.on('show.bs.popover', self.needContent);
            self.$popover.on('hidden.bs.popover', () => {
                if (self._needRecreatePopover) {
                    self._needRecreatePopover = false;
                    self.destroyPopover(self.createPopover);
                }
            });
        }
    }
    
    destroyPopover(callback) {
        const self = this;

        if (self.$popover) {
            self.$popover.off();
            const $popover = self.$popover;
            self.$popover = null;

            setTimeout(
                () => {
                    $popover.popover('dispose');
                    if (typeof callback === 'function') {
                        callback();
                    }
                }, 
                showDelay + 100);
        }
        else if (typeof callback === 'function') {
            callback();
        }
    }

    updatePopover() {
        const self = this;

        if (Boolean(self.$popover)) {
            const popoverData = self.$popover.data('bs.popover');

            if (Boolean(popoverData)) {
                let needUpdate = false;

                for (var key in self.state.popoverConfig) {
                    needUpdate = self.state.popoverConfig[key] != popoverData.config[key];
                    if (needUpdate) {
                        break;
                    }
                }

                if (needUpdate) {
                    self._needRecreatePopover = self._needRecreatePopover || (popoverData.config.trigger != self.state.popoverConfig.trigger);
                    Object.assign(popoverData.config, self.state.popoverConfig);

                    popoverData.setContent();
                    
                    if (self.isHidden()) {
                        self.$popover.popover('hide');
                    }
                    else {
                        self.$popover.popover('update');
                    }
                }
            }
        }
    }

    isHidden() {
        return !Boolean(this.state.popoverConfig.content);
    }

    getPopoverConfig(props) {
        const isInit = Boolean(props);

        const self = this;
        props = props || self.props;

        const trigger = ToString(props.trigger);

        const placement = Boolean(props.placement) 
            ? props.placement : 
            () => {return ($(window).width() > fixedWith * 2) ? 'right' : 'bottom';}

        const result = {
            hasHtmlForm: false,
            placement: placement,
            boundary: 'window',
            delay: {show: showDelay, hide: 100},
            template: FormatString(self.constructor.popupTemplate, ToString(props.popoverClassName)),
            title: props.title,
        };

        let showCopyButton = Boolean(props.showCopyButton) && !Boolean(props.title);

        if (typeof props.text === 'function') {
            if (isInit || self.state.isLoading) {
                result.content = '<div class="text-center"><span class="text-secondary fa fa-sun-o fa-spin"></span></div>';
                result.html = true;
                result.trigger = trigger || 'hover focus';
                showCopyButton = false;
            }
            else {
                result.content = self.state.popoverConfig.content;
                result.html = self.state.popoverConfig.html;
                result.trigger = self.state.popoverConfig.trigger;
            }
        }
        else if (React.isValidElement(props.text)) {
            result.html = true;
            result.content = ReactDOMServer.renderToStaticMarkup(props.text);
            result.hasHtmlForm = isTextHasHtmlForm(result.content);
            result.trigger = trigger || 'hover focus'; 
        }
        else {
            result.content = ToString(props.text);
            result.hasHtmlForm = isTextHasHtmlForm(result.content);
            result.html = result.hasHtmlForm || isTextWithHtml(result.content);
            result.trigger = trigger || 'hover focus';
        }

        if (result.hasHtmlForm || Boolean(props.showCopyButton)) {
            result.delay.hide = 1500;
        }

        if (showCopyButton) {
            result.title = FormatString(ItemPopupDescriptionComponent.titleTemplate, '');
            result.html = true;
        }

        return result;
    }

    needContent() {
        const self = this;

        if ((typeof self.props.text === 'function') && !self.state.isLoaded && !self.state.isLoading) {
            new Promise(resolve => self.setState({isLoading: true}, resolve))
                .then(() => {
                    if (self._isMounted) {
                        const result = self.props.text();
                        return Promise.resolve(result);
                    }
                })
                .then(content => {
                    if (self._isMounted) {
                        const popoverConfig = {...self.state.popoverConfig};
                        const strContent = ToString(content);
                        popoverConfig.content = strContent;
                        popoverConfig.hasHtmlForm = isTextHasHtmlForm(strContent);
                        popoverConfig.html = popoverConfig.hasHtmlForm || isTextWithHtml(strContent);
                        popoverConfig.trigger = ToString(self.props.trigger) || 'hover focus';
                        self.setState({isLoaded: true, isLoading: false, popoverConfig: popoverConfig});
                    }
                })
                .catch(e => {
                    if (self._isMounted) {
                        const popoverConfig = {...self.state.popoverConfig};
                        popoverConfig.content = ReactDOMServer.renderToStaticMarkup(<ErrorsBlockComponent errors={e} unstyled />);
                        popoverConfig.html = true;
                        popoverConfig.trigger = 'manual';

                        self.setState({isLoaded: true, isLoading: false, popoverConfig: popoverConfig});
                    }
                });
        }
    }

    render() {
        const self = this;

        if (self.isHidden() && !self.props.showIfEmpty) {
            return null;
        }

        const props = {...self.props};

        const content = Boolean(props.children) 
            ? props.children 
            : <i className="sbkico-info text-info" />

        const className = 
            'popup-description skipautofocus text-decoration-none outline-none ' + 
            (props.className || '') + 
            (((self.state.popoverConfig.trigger || '').indexOf('focus') > -1) || Boolean(self.state.popoverConfig.hasHtmlForm) ? '' : ' cursor-default');

        props.className = NormalizeClassNameString(className);

        delete props.children;
        delete props.onClick;
        delete props.popoverClassName;
        delete props.placement;
        delete props.text;
        delete props.title;
        delete props.trigger;
        delete props.showCopyButton;
        delete props.showIfEmpty;

        props.href = '#';
        props['data-toggle'] = self._popoverId;
        props.onClick = preventDefault;

        return <a {...props}>{content}</a>
    }
}
ItemPopupDescriptionComponent.popoverCounter = 0;
ItemPopupDescriptionComponent.popupTemplate = '<div class="popover popover-fixedwidth {0}" role="tooltip"><div class="popover-header"></div><div class="popover-body text-pre-line"></div><div class="arrow"></div></div>';
ItemPopupDescriptionComponent.titleTemplate = '<div class="d-flex">{0}<span class="sbkico-copy cursor-pointer ml-auto btn-copy-popover-content fs-sm"></span></div>';
ItemPopupDescriptionComponent.propTypes = {
    className: PropTypes.string,
    popoverClassName: PropTypes.string,
    placement: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
    title: PropTypes.string,
    trigger: PropTypes.string,
    showCopyButton: PropTypes.bool,
    showIfEmpty: PropTypes.bool,
}
ItemPopupDescriptionComponent.defaultProps = {
    popoverClassName: 'popover-default',
    title: '',
    showCopyButton: false,
    showIfEmpty: false,
}
